import { rest } from 'utils';

export default {
  create: ({ group }) => rest.post({ url: 'um/groups', body: group }),
  get: ({ id }) => rest.get({ url: `um/groups/${id}?depth=1` }),
  getAll: () => rest.get({ url: 'um/groups?depth=1' }),
  update: ({ id, group }) => rest.put({ url: `um/groups/${id}`, body: group }),
  delete: ({ id }) => rest.delete({ url: `um/groups/${id}` }),
  addUser: ({ groupId, userId }) => rest.post({ url: `um/groups/${groupId}/users`, body: { id: userId } }),
  getUsers: ({ groupId }) => rest.get({ url: `um/groups/${groupId}/users?depth=2` }),
  deleteUser: ({ groupId, userId }) => rest.delete({ url: `um/groups/${groupId}/users/${userId}` }),
  addResource: ({ groupId, resourceId }) => rest.post({ url: `um/groups/${groupId}/shares/${resourceId}` }),
  getResources: ({ groupId }) => rest.get({ url: `um/groups/${groupId}/resources?depth=2` }),
  deleteResource: ({ groupId, resourceId }) => rest.delete({ url: `um/groups/${groupId}/shares/${resourceId}` }),
};
